import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigationStore } from '@/stores/navigation-store';

/**
 * NavigationTracker
 * 
 * Invisible component that tracks route changes and updates the navigation store.
 * Mount this once inside your router (e.g., inside BrowserRouter in App.tsx).
 * 
 * Usage:
 * ```tsx
 * <BrowserRouter>
 *   <NavigationTracker />
 *   <Routes>...</Routes>
 * </BrowserRouter>
 * ```
 */
export const NavigationTracker = () => {
  const location = useLocation();
  const onRouteChange = useNavigationStore((state) => state.onRouteChange);

  useEffect(() => {
    onRouteChange(location.pathname);
  }, [location.pathname, onRouteChange]);

  return null;
};

export default NavigationTracker;
